module.exports = __webpack_public_path__ + "media/cart-loading.63d89745.mp4";